import sortItems from '../functions/sortItems'
import hydrateWatchlist from '../functions/hydrateWatchlist'

type prop = {
  itemIds: number[]
  instance: any
  watchlistItemIds?: number[]
  cancelToken?: any
}

const getUpdatedItems = async ({
  itemIds,
  instance,
  watchlistItemIds = [],
  cancelToken,
}: prop) => {
  const url = `/item/getUpdateItemsInfo`
  const params = { itemIds }
  if (!itemIds.length) return []
  try {
    const config = {
      params,
      paramsSerializer: { indexes: null },
      timeout: 5000,
      cancelToken: undefined,
    }

    if (cancelToken) {
      config.cancelToken = cancelToken
    }

    const {
      data: { items },
    } = await instance.get(url, config)
    if (!items) return null
    const sortedItems = sortItems(
      items.map(({ enableEmail, enableSMS, ...item }: any) => item),
      itemIds
    )
    return hydrateWatchlist(sortedItems, watchlistItemIds)
  } catch (e) {}
}

export default getUpdatedItems
